module.exports = __webpack_public_path__ + "c11ca225a92b8f8a2323ecec3c3fda37.gif";